/** Build-time gate — Faro SDK is only loaded when this is true and a collector URL exists. */
export const isGrafanaFaroEnabled =
  process.env.NEXT_PUBLIC_GRAFANA_FARO_ENABLED === 'true' &&
  Boolean(process.env.NEXT_PUBLIC_GRAFANA_FARO_URL?.trim());
